import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AreaComponent } from '../../investment-projects/investment-project/charts/area/area.component';
import { PieComponent } from '../../investment-projects/investment-project/charts/pie/pie.component';
import { InfoButtonComponent } from 'src/app/components/info-button/info-button.component';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [PieComponent, AreaComponent, InfoButtonComponent],
  templateUrl: './summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryComponent {}
